// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Master Catalogue — MCR Brands visual language
   ========================================================================== */

.mcat-page {
  padding: 24px;
  background: #f4f5f7;
  min-height: calc(100vh - 60px);
}

.mcat-card {
  max-width: 1180px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  border-radius: 18px;
  box-shadow: 0 10px 40px -18px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}

/* ---------- Header ---------------------------------------------- */
.mcat-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 28px;
  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%);
  color: #f8fafc;
}

.mcat-head-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.mcat-head-sub {
  margin: 5px 0 0;
  font-size: 12px;
  color: #c9bef0;
}

.mcat-head-count {
  padding: 8px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 12.5px;
  font-weight: 700;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* ---------- Toolbar ------------------------------------------- */
.mcat-toolbar {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr auto;
  gap: 10px;
  padding: 16px 24px;
  background: #fbfbfc;
  border-bottom: 1px solid #eceef1;
}

.mcat-input,
.mcat-select {
  height: 38px;
  border: 1px solid #dfe3e8;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 13px;
  color: #1f2937;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.mcat-input:focus,
.mcat-select:focus {
  border-color: #7c5cfc;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.18);
}

.mcat-clear {
  height: 38px;
  padding: 0 16px;
  border: 1px solid #f0c9c9;
  border-radius: 10px;
  background: #fff5f5;
  color: #b91c1c;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;
}
.mcat-clear:hover {
  background: #ffe6e6;
}

@media (max-width: 820px) {
  .mcat-toolbar {
    grid-template-columns: 1fr 1fr;
  }
}

/* ---------- Table ------------------------------------------- */
.mcat-scroll {
  overflow-x: auto;
}

.mcat-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
  min-width: 720px;
}

.mcat-table thead th {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ede9fb;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  text-align: left;
  padding: 14px 18px;
  border-bottom: 1px solid #5b3fc8;
  white-space: nowrap;
}

.mcat-th-check { width: 46px; text-align: center; }
.mcat-th-img { width: 74px; }
.mcat-th-price { width: 150px; text-align: right; }

.mcat-table tbody td {
  padding: 12px 18px;
  border-bottom: 1px solid #eef0f3;
  color: #1f2937;
  vertical-align: middle;
}

.mcat-table tbody tr {
  cursor: pointer;
  transition: background 0.14s ease;
}

.mcat-table tbody tr:hover {
  background: #f8fafc;
}

.mcat-table tbody tr.is-selected {
  background: #f3efff;
}

.mcat-table tbody tr.is-selected:hover {
  background: #ece5ff;
}

.mcat-table tbody tr:last-child td {
  border-bottom: none;
}

.mcat-check {
  width: 17px;
  height: 17px;
  accent-color: #4c2fb3;
  cursor: pointer;
}

.mcat-thumb {
  width: 46px;
  height: 46px;
  border-radius: 9px;
  border: 1px solid #e5e7eb;
  background: #fafafa;
  object-fit: contain;
  display: block;
}

.mcat-name {
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mcat-meta {
  margin-top: 3px;
  font-size: 11.5px;
  color: #64748b;
}

.mcat-instore {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: #dcfce7;
  color: #15803d;
  border: 1px solid #86efac;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.mcat-price {
  text-align: right;
  white-space: nowrap;
}

.mcat-price-now {
  font-size: 13.5px;
  font-weight: 800;
  color: #4c2fb3;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.mcat-price-mrp {
  margin-left: 6px;
  font-size: 11.5px;
  color: #94a3b8;
  text-decoration: line-through;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

/* ---------- States --------------------------------------- */
.mcat-state {
  padding: 60px 24px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}

/* ---------- Pagination ---------------------------------- */
.mcat-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 24px;
  background: #fbfbfc;
  border-top: 1px solid #eceef1;
}

.mcat-pager-info {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.mcat-pager-btn {
  height: 32px;
  padding: 0 14px;
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.14s ease, border-color 0.14s ease, color 0.14s ease;
}
.mcat-pager-btn:hover:not(:disabled) {
  color: #4c2fb3;
  border-color: #c9bef0;
  background: #f5f3ff;
}
.mcat-pager-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ---------- Selection bar ------------------------------- */
.mcat-selbar {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 22px;
  z-index: 1030;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 12px 14px 12px 22px;
  border-radius: 16px;
  background: linear-gradient(135deg, #24123f 0%, #4c2fb3 60%, #7c5cfc 100%);
  box-shadow: 0 18px 40px -12px rgba(76, 47, 179, 0.55);
  color: #ffffff;
}

.mcat-selbar-count {
  font-size: 13px;
  font-weight: 700;
}

.mcat-selbar-clear {
  margin-left: 10px;
  font-size: 11.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
  background: none;
  border: none;
  cursor: pointer;
}
.mcat-selbar-clear:hover {
  color: #ffffff;
}

.mcat-selbar-add {
  border: none;
  border-radius: 999px;
  padding: 9px 20px;
  background: #ffffff;
  color: #4c2fb3;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}
.mcat-selbar-add:hover {
  background: #ede9fb;
}

/* ---------- Warehouse modal --------------------------- */
.mcat-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.mcat-modal {
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  overflow: hidden;
  box-shadow: 0 24px 60px -12px rgba(15, 23, 42, 0.4);
}

.mcat-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
}

.mcat-modal-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.mcat-modal-close {
  background: none;
  border: none;
  color: #ffffff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.mcat-modal-body {
  padding: 16px 20px;
}

.mcat-modal-note {
  font-size: 12px;
  color: #64748b;
  margin: 0 0 10px;
}

.mcat-wh-list {
  max-height: 320px;
  overflow-y: auto;
}

.mcat-wh-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 4px;
  border-bottom: 1px solid #eef0f3;
}

.mcat-wh-name {
  font-weight: 500;
  color: #0f172a;
}
.mcat-wh-row.is-on .mcat-wh-name {
  font-weight: 700;
  color: #4c2fb3;
}

.mcat-wh-city {
  font-size: 12px;
  color: #64748b;
}

.mcat-wh-added {
  font-size: 11px;
  color: #94a3b8;
  font-style: italic;
}

.mcat-modal-submit {
  width: 100%;
  margin-top: 14px;
  border: none;
  border-radius: 10px;
  padding: 11px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.mcat-modal-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/catalog/MasterCatalogue.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,6CAA6C;EAC7C,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,iBAAiB,WAAW,EAAE,kBAAkB,EAAE;AAClD,eAAe,WAAW,EAAE;AAC5B,iBAAiB,YAAY,EAAE,iBAAiB,EAAE;;AAElD;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB,0EAA0E;EAC1E,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* ==========================================================================\n   Master Catalogue — MCR Brands visual language\n   ========================================================================== */\n\n.mcat-page {\n  padding: 24px;\n  background: #f4f5f7;\n  min-height: calc(100vh - 60px);\n}\n\n.mcat-card {\n  max-width: 1180px;\n  margin: 0 auto;\n  background: #ffffff;\n  border: 1px solid #e6e8ec;\n  border-radius: 18px;\n  box-shadow: 0 10px 40px -18px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n}\n\n/* ---------- Header ---------------------------------------------- */\n.mcat-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 22px 28px;\n  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%);\n  color: #f8fafc;\n}\n\n.mcat-head-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.mcat-head-sub {\n  margin: 5px 0 0;\n  font-size: 12px;\n  color: #c9bef0;\n}\n\n.mcat-head-count {\n  padding: 8px 16px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  font-size: 12.5px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n/* ---------- Toolbar ------------------------------------------- */\n.mcat-toolbar {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr 1fr 1fr auto;\n  gap: 10px;\n  padding: 16px 24px;\n  background: #fbfbfc;\n  border-bottom: 1px solid #eceef1;\n}\n\n.mcat-input,\n.mcat-select {\n  height: 38px;\n  border: 1px solid #dfe3e8;\n  border-radius: 10px;\n  padding: 0 12px;\n  font-size: 13px;\n  color: #1f2937;\n  background: #ffffff;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.mcat-input:focus,\n.mcat-select:focus {\n  border-color: #7c5cfc;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.18);\n}\n\n.mcat-clear {\n  height: 38px;\n  padding: 0 16px;\n  border: 1px solid #f0c9c9;\n  border-radius: 10px;\n  background: #fff5f5;\n  color: #b91c1c;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease;\n}\n.mcat-clear:hover {\n  background: #ffe6e6;\n}\n\n@media (max-width: 820px) {\n  .mcat-toolbar {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* ---------- Table ------------------------------------------- */\n.mcat-scroll {\n  overflow-x: auto;\n}\n\n.mcat-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n  min-width: 720px;\n}\n\n.mcat-table thead th {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ede9fb;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  text-align: left;\n  padding: 14px 18px;\n  border-bottom: 1px solid #5b3fc8;\n  white-space: nowrap;\n}\n\n.mcat-th-check { width: 46px; text-align: center; }\n.mcat-th-img { width: 74px; }\n.mcat-th-price { width: 150px; text-align: right; }\n\n.mcat-table tbody td {\n  padding: 12px 18px;\n  border-bottom: 1px solid #eef0f3;\n  color: #1f2937;\n  vertical-align: middle;\n}\n\n.mcat-table tbody tr {\n  cursor: pointer;\n  transition: background 0.14s ease;\n}\n\n.mcat-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.mcat-table tbody tr.is-selected {\n  background: #f3efff;\n}\n\n.mcat-table tbody tr.is-selected:hover {\n  background: #ece5ff;\n}\n\n.mcat-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.mcat-check {\n  width: 17px;\n  height: 17px;\n  accent-color: #4c2fb3;\n  cursor: pointer;\n}\n\n.mcat-thumb {\n  width: 46px;\n  height: 46px;\n  border-radius: 9px;\n  border: 1px solid #e5e7eb;\n  background: #fafafa;\n  object-fit: contain;\n  display: block;\n}\n\n.mcat-name {\n  font-weight: 600;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mcat-meta {\n  margin-top: 3px;\n  font-size: 11.5px;\n  color: #64748b;\n}\n\n.mcat-instore {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #dcfce7;\n  color: #15803d;\n  border: 1px solid #86efac;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.mcat-price {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.mcat-price-now {\n  font-size: 13.5px;\n  font-weight: 800;\n  color: #4c2fb3;\n  font-variant-numeric: tabular-nums;\n}\n\n.mcat-price-mrp {\n  margin-left: 6px;\n  font-size: 11.5px;\n  color: #94a3b8;\n  text-decoration: line-through;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------- States --------------------------------------- */\n.mcat-state {\n  padding: 60px 24px;\n  text-align: center;\n  color: #64748b;\n  font-size: 14px;\n}\n\n/* ---------- Pagination ---------------------------------- */\n.mcat-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 24px;\n  background: #fbfbfc;\n  border-top: 1px solid #eceef1;\n}\n\n.mcat-pager-info {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  font-variant-numeric: tabular-nums;\n}\n\n.mcat-pager-btn {\n  height: 32px;\n  padding: 0 14px;\n  border: 1px solid #dfe3e8;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.14s ease, border-color 0.14s ease, color 0.14s ease;\n}\n.mcat-pager-btn:hover:not(:disabled) {\n  color: #4c2fb3;\n  border-color: #c9bef0;\n  background: #f5f3ff;\n}\n.mcat-pager-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ---------- Selection bar ------------------------------- */\n.mcat-selbar {\n  position: fixed;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 22px;\n  z-index: 1030;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 12px 14px 12px 22px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #24123f 0%, #4c2fb3 60%, #7c5cfc 100%);\n  box-shadow: 0 18px 40px -12px rgba(76, 47, 179, 0.55);\n  color: #ffffff;\n}\n\n.mcat-selbar-count {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.mcat-selbar-clear {\n  margin-left: 10px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.75);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.mcat-selbar-clear:hover {\n  color: #ffffff;\n}\n\n.mcat-selbar-add {\n  border: none;\n  border-radius: 999px;\n  padding: 9px 20px;\n  background: #ffffff;\n  color: #4c2fb3;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.mcat-selbar-add:hover {\n  background: #ede9fb;\n}\n\n/* ---------- Warehouse modal --------------------------- */\n.mcat-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.mcat-modal {\n  background: #ffffff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 480px;\n  overflow: hidden;\n  box-shadow: 0 24px 60px -12px rgba(15, 23, 42, 0.4);\n}\n\n.mcat-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n}\n\n.mcat-modal-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.mcat-modal-close {\n  background: none;\n  border: none;\n  color: #ffffff;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.mcat-modal-body {\n  padding: 16px 20px;\n}\n\n.mcat-modal-note {\n  font-size: 12px;\n  color: #64748b;\n  margin: 0 0 10px;\n}\n\n.mcat-wh-list {\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.mcat-wh-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 4px;\n  border-bottom: 1px solid #eef0f3;\n}\n\n.mcat-wh-name {\n  font-weight: 500;\n  color: #0f172a;\n}\n.mcat-wh-row.is-on .mcat-wh-name {\n  font-weight: 700;\n  color: #4c2fb3;\n}\n\n.mcat-wh-city {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.mcat-wh-added {\n  font-size: 11px;\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.mcat-modal-submit {\n  width: 100%;\n  margin-top: 14px;\n  border: none;\n  border-radius: 10px;\n  padding: 11px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.mcat-modal-submit:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
